// extracted by mini-css-extract-plugin
module.exports = {"container":"InfluencersUgcSectionTitle_container__MWcR2","title":"InfluencersUgcSectionTitle_title__Dq41c"};